var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parking-canvas" },
    [
      _c(
        "div",
        { staticClass: "parking-canvas__panzoom" },
        [
          _c(
            "PanZoom",
            {
              attrs: { options: _vm.options },
              on: { registerSvgPanZoom: _vm.registerSvgPanZoom },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: [
                      "0 0 " + _vm.render.width + " " + _vm.render.height,
                    ],
                    preserveAspectRatio: "xMidYMid meet",
                  },
                },
                [
                  _vm._l(_vm.elements, function (element) {
                    return _c("path", {
                      key: element.id,
                      ref: "path",
                      refInFor: true,
                      staticClass: "parking-canvas__path",
                      attrs: {
                        d: element.path,
                        id: "path-" + element.id,
                        fill: element.fill ? element.fill : "#95BA20",
                      },
                      on: {
                        mouseenter: function ($event) {
                          return _vm.mouseenter(element)
                        },
                        mousemove: function ($event) {
                          return _vm.mousemove(element)
                        },
                        mouseleave: function ($event) {
                          return _vm.mouseleave(element)
                        },
                      },
                    })
                  }),
                  _vm._v(" "),
                  _c("image", {
                    staticClass: "parking-canvas__image",
                    attrs: {
                      x: "0",
                      y: "0",
                      width: "100%",
                      height: "100%",
                      "xlink:href": _vm.render.src,
                    },
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c("Panel", {
            attrs: { data: _vm.activeElement },
            on: {
              close: function ($event) {
                _vm.activeElement = null
              },
              submit: _vm.clickPath,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("Tooltip"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }